module.exports = __webpack_public_path__ + "img/sign-66.601a4e74.jpg";